// @flow

import React, { Component } from 'react';

import type { Element } from 'react';

import localforage from 'localforage';
import timesSeries from 'async/timesSeries';
import _ from 'lodash';
import $ from 'jquery';
import Alert from 'react-s-alert';

import Map from './Map.jsx';
import Indicator from './Indicator.jsx';
import App from './App.jsx';
import Escala from './Escala.jsx';

import {takeDir, get_service_part, show_service} from './utils.js';
import {fetch_shp, fetch_png} from './fetch_things.js';
import {SIDEBAR_WIDTH} from './consts.js';

import type {T_Next, T_NextNum, T_NextPaths} from './types.js';

import './css/FourMaps.css';



type T_FourMapsProps = {
  shp               : string,
  img               : string,
  show_tree         : boolean,
  width             : number,
  height            : number,
  show_dialog_user  : boolean,
  show_dialog_tools : boolean,
  dev_mode          : boolean,
  full_height       : boolean,
  symmetric         : boolean,
  show_escalas_below: boolean,
  app               : App
};


type T_FourMapsState = {
  active_map: number,
  images    : Array<string>,
  widths    : Array<number>
};


type T_FourMapsReport = {
  loaded : Array<string>,
  hilight: string,
  escala : string
};


type T_LbPos = {
  left      : number,
  top       : number,
  fontWeight: string
};



export function dead_four_maps(app: App): boolean {
  return app.four_maps == null || app.state.closing_four_maps || ! app.state.four_maps;
}



export default class FourMaps extends Component<T_FourMapsProps, T_FourMapsState> {
  destroy      : (next_fun: T_Next) => void;
  activate_map : (i: number, next?: T_Next) => void;
  img_loaded   : (path: string, loaded: boolean, next: T_Next) => void;
  
  map_refs    : Array<?Map>;
  
  
  
  constructor(props: T_FourMapsProps) {
    super(props);
    
    this.state = {
      active_map: -1,
      images    : ['', '', '', ''],
      widths    : [0, 0, 0, 0]
    };
    
    this.map_refs = [null, null, null, null];
    
    this.destroy      = this.destroy.bind(this);
    this.activate_map = this.activate_map.bind(this);
    this.img_loaded   = this.img_loaded.bind(this);
    
    props.app.four_maps = this;
  }
  
  
  
  componentDidUpdate(prevProps: T_FourMapsProps, prevState: T_FourMapsState) {
    if ((! this.props.symmetric) && (! _.isEqual(prevState.images, this.state.images))) {
      this.center_labels();
    }
    
    if (prevProps.show_escalas_below !== this.props.show_escalas_below) {
      _.delay(() => this.forceUpdate(), 100);   // Why, react, why?
    }
  }
  
  
  
  not_ready(): void {
    for (let num = 0; num < 4; num += 1) {
      this.props.app.is_ready[`Map${num}`] = false;
    }
  }
  
  
  
  componentWillMount() {
    this.not_ready();
  }
  
  
  
  componentWillUnmount() {
    this.not_ready();
    
    this.props.app.four_maps = null;
  }
  
  
  
  center_all(path: string, next: T_Next): void {
    const {app} = this.props;
    
    timesSeries(4, (num: number, next) => {
      if (this.map_refs[num] != null) {
        app.map_ui.map = this.map_refs[num];
        
        app.map_ui.map.center_and_zoom_path(path, true);
      }
      
      next(null, 0);
    }, (err, rs) => {
      next(true);
    });
  }
  
  
  
  destroy(next_fun: T_Next): void {
    const {app} = this.props;
    
    localforage.getItem(`${app.state.user.user_name}.last_png`).then((last_png) => {
      timesSeries(4, (num: number, next) => {
        if (this.map_refs[num] != null) {
          app.map_ui.map = this.map_refs[num];
          
          app.map_ui.close_all(() => {
            app.refresh_items(() => {
              app.map_ui.map.destroy();
              next(null, 0);
            });
          });
        }
        else {
          console.log(`No encuentro el mapa ${num} para destruirlo.`);
          
          next(null, 0);
        }
      }, (err, rs) => {
        localforage.setItem(`${app.state.user.user_name}.last_png`, last_png).then(() => {  // FIXME: ESTE SETEO ES SUFICIENTE?
          next_fun(true);
        });
      });
    });
  }
  
  
  
  setup(post?: T_Next): void {
    const {app} = this.props;
    
    if (dead_four_maps(app)) {
      if (post != null && _.isFunction(post)) {
        post(false);
      }
    
      return;
    }
    
    fetch_shp(app, this.props.shp, (shp) => {
      fetch_png(app, this.props.img, (img) => {
        timesSeries(4, (num: number, next) => {
          if (this.map_refs[num] != null) {
            const map: Map = this.map_refs[num];
            
            if (typeof shp !== 'string') {
              app.map_ui.show_shp(shp, () => {
                if (((this.props.symmetric && num === 0) || (! this.props.symmetric && num === 1)) && typeof img !== 'string') {
                  if (this.props.dev_mode && img.has_lyrs) {
                    img.nodeUrl = img.nodeUrl + app.esc_url_params();
                  }
                  
                  app.map_ui.show_img(img, () => {
                    const images = _.cloneDeep(this.state.images);
                    
                    images[1] = this.props.img;
                    
                    this.setState({images}, () => next(null, 0));
                  }, map);
                }
                else {
                  next(null, 0);
                }
              }, map);
            }
            else {
              next(null, 0);
            }
          }
          else {
            console.log(`FourMaps setup: el mapa ${num} no está listo`);
            
            next(null, 0);
          }
        }, (err, rs) => {
          this.activate_map(this.props.symmetric ? 0 : 1, () => {
            if (post != null && _.isFunction(post)) {
              post(true);
            }
          });
        });
      });
    });
  }
  
  
  
  get_map_state(): T_FourMapsReport {
    const {app} = this.props;
    
    return {
      loaded : app.map_ui.map.things_loaded(),
      hilight: app.map_ui.map.last_shp_path(),
      escala : app.map_ui.map.last_img_path()
    };
  }
  
  
  
  activate_map(num: number, next?: T_Next): void {
    if (typeof num !== 'number' || num === -1 || this.state.active_map === num) {
      if (next != null && _.isFunction(next)) {
        return next(false);
      }
      else {
        return;
      }
    }
    
    const {app}    = this.props,
          last_png = app.map_ui.map.last_img_path(takeDir(app.map_ui.map.last_shp_path()));
    
    if (this.map_refs[num] != null) {
      app.map_ui.map = this.map_refs[num];
      
      app.refresh_items(() => {
        this.setState({active_map: num}, () => {
          localforage.setItem(`${app.state.user.user_name}.last_png`, last_png).then(() => {
            if (next != null && _.isFunction(next)) {
              next(true);
            }
          });
        });
      });
    }
    else {
      Alert.error(`No encuentro el mapa número ${num}`);
    }
  }
  
  
  
  activate_map_with(png_path: string, next?: T_Next): void {
    let index = -1;
    
    if (this.map_refs[0] != null && _.has(this.map_refs[0].Img_List, png_path)) {
      index = 0;
    }
    if (this.map_refs[1] != null && _.has(this.map_refs[1].Img_List, png_path)) {
      index = 1;
    }
    if (this.map_refs[2] != null && _.has(this.map_refs[2].Img_List, png_path)) {
      index = 2;
    }
    if (this.map_refs[3] != null && _.has(this.map_refs[3].Img_List, png_path)) {
      index = 3;
    }
    
    this.activate_map(index, next);
  }
  
  
  
  get_free_low_map(next: T_NextNum) {    // NOTE: devuelve -1 si no hay ningún mapa libre
    const {app} = this.props;
    
    this.activate_map(1, () => {
      if (! app.map_ui.map.has_images_loaded()) {
        next(1);
      }
      else {
        this.activate_map(2, () => {
          if (! app.map_ui.map.has_images_loaded()) {
            next(2);
          }
          else {
            this.activate_map(3, () => {
              next(app.map_ui.map.has_images_loaded() ? -1 : 3);
            });
          }
        });
      }
    });
  }
  
  
  
  get_low_images(next: T_NextPaths): void {
    const xs    = [],
          {app} = this.props;
    
    this.activate_map(1, () => {
      xs.push(app.map_ui.map.last_img_path());
      
      this.activate_map(2, () => {
        xs.push(app.map_ui.map.last_img_path());
        
        this.activate_map(3, () => {
          xs.push(app.map_ui.map.last_img_path());
          
          next(xs.filter(_.identity));
        });
      });
    });
  }
  
  
  
  add_low_image(path: string, next: T_Next): void {
    const {app} = this.props;
    
    const load = () => {
      const item_png = app.get_item_png(path);
      
      if (item_png != null) {
        item_png.open(() => next(true));
      }
      else {
        next(false);
      }
    };
    
    this.get_free_low_map((map_num: number) => {
      if (map_num === -1) {
        this.activate_map(3, () => {
          this.kill_low_image(app.map_ui.map.last_img_path(), load);
        });
      }
      else {
        this.activate_map(map_num, load);
      }
    });
  }
  
  
  
  kill_low_image(path: string, next: T_Next): void {
    const {app} = this.props;
    
    this.activate_map(1, () => {
      if (app.map_ui.map.is_loaded(path)) {
        const item_png = app.get_item_png(path);
        
        if (item_png != null) {
          item_png.close(() => next(true));
        }
        else {
          next(false);
        }
      }
      else {
        this.activate_map(2, () => {
          if (app.map_ui.map.is_loaded(path)) {
            const item_png = app.get_item_png(path);
            
            if (item_png != null) {
              item_png.close(() => next(true));
            }
            else {
              next(false);
            }
          }
          else {
            this.activate_map(3, () => {
              if (app.map_ui.map.is_loaded(path)) {
                const item_png = app.get_item_png(path);
                
                if (item_png != null) {
                  item_png.close(() => next(true));
                }
                else {
                  next(false);
                }
              }
              else {
                next(false);
              }
            });
          }
        });
      }
    });
  }
  
  
  
  reload_ms_icons(): void {
    for (let num = 0; num < 4; num += 1) {
      if (this.map_refs[num] != null) {
        this.map_refs[num].reload_ms_icons();
      }
    }
  }
  
  
  
  img_loaded(path: string, loaded: boolean, next: T_Next): void {
    const {app} = this.props;
    
    if (dead_four_maps(app)) {
      return next(false);
    }
    
    const images = _.cloneDeep(this.state.images);
    
    images[this.state.active_map] = loaded ? path : '';
    
    this.setState({images});
  }
  
  
  
  get_label_of(png_path: string): string {
    if (png_path) {
      const item_png = this.props.app.get_item_png(png_path);
      
      if (item_png) {
        return (
          this.props.symmetric ?
            item_png.props.node.label
          :
            `${item_png.props.node.label}, ${show_service(get_service_part(png_path))}`
        );
      }
      else {
        return '';
      }
    }
    else {
      return '';
    }
  }
  
  
  
  center_labels(): void {
    this.setState({
      widths: [
        this.state.images[0] === '' ? 0 : $('#lb4M0').width(),
        this.state.images[1] === '' ? 0 : $('#lb4M1').width(),
        this.state.images[2] === '' ? 0 : $('#lb4M2').width(),
        this.state.images[3] === '' ? 0 : $('#lb4M3').width()
      ]
    });
  }
  
  
  
  render_label(path: string, pos: T_LbPos, index: number): ?Element<string> {
    if (path === '') {
      return null;
    }
    else {
      return (
        <div className='lb_fourmaps' id={`lb4M${index}`} style={pos} key={index}>
          {this.get_label_of(path)}
        </div>
      );
    }
  }
  
  
  
  render() {
    const {app}  = this.props,
          Width  = this.props.width - SIDEBAR_WIDTH,
          Top    = 4,
          Middle = (this.props.height * (this.props.symmetric ? 0.5 : 0.75)) - (this.props.full_height ? -3 : 12),
          Left   = Width * 0.24,
          Right  = Width * 0.74,
          pos = [
            {left: Left , top: Top   , fontWeight: this.props.symmetric && this.state.active_map === 0 ? 'bold' : 'normal'},
            {left: Right, top: Top   , fontWeight: this.props.symmetric && this.state.active_map === 1 ? 'bold' : 'normal'},
            {left: Left , top: Middle, fontWeight: this.props.symmetric && this.state.active_map === 2 ? 'bold' : 'normal'},
            {left: Right, top: Middle, fontWeight: this.props.symmetric && this.state.active_map === 3 ? 'bold' : 'normal'}
          ];
    
    if (! this.props.symmetric) {
      const HMid = Width / 2,
            H1   = Width / 6,
            H3   = Width * (5 / 6);
      
      pos[0].left = HMid;
      pos[1].top  = Middle;
      pos[1].left = H1   - (this.state.widths[1] / 2);
      pos[2].left = HMid - (this.state.widths[2] / 2);
      pos[3].left = H3   - (this.state.widths[3] / 2);
    }
    
    const esc = this.state.images.map((image, num) => {
      if (num > 0 && (! this.props.show_escalas_below) && (! this.props.symmetric)) {
        return null;
      }
      
      if (this.map_refs[num] != null && _.has(this.map_refs[num].Img_List, image)) {
        return (
          <Escala
            escala_for={image}
            window_drag={true}
            dev_mode={false}
            use_color_brewer={false}
            esc={this.map_refs[num].Img_List[image].obj.esc}
            lyr={null}
            app={this.props.app}
            frame_drag={false}
            no_close={true}
            toggleable={true}
          />
        );
      }
      else {
        return null;
      }
    });
    
    return (
      <div className='map_container'>
        {this.state.images.map((path, index) => this.render_label(path, pos[index], index))}
        
        {this.props.symmetric ?
          <table id='tablemaps'>
            <tbody>
              <tr>
                <td>
                  {esc[0]}
                  
                  <Map
                    name='Map0'
                    num={0}
                    on_click={this.activate_map}
                    on_img={this.img_loaded}
                    app={app}
                    map_bts={false}
                    escala_for={this.state.images[0]}
                    map_border={false}
                    four_maps={this}
                  />
                </td>
                <td>
                  {esc[1]}
                  
                  <Map
                    name='Map1'
                    num={1}
                    on_click={this.activate_map}
                    on_img={this.img_loaded}
                    app={app}
                    map_bts={false}
                    escala_for={this.state.images[1]}
                    map_border={false}
                    four_maps={this}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {esc[2]}
                  
                  <Map
                    name='Map2'
                    num={2}
                    on_click={this.activate_map}
                    on_img={this.img_loaded}
                    app={app}
                    map_bts={false}
                    escala_for={this.state.images[2]}
                    map_border={false}
                    four_maps={this}
                  />
                </td>
                <td>
                  {esc[3]}
                  
                  <Map
                    name='Map3'
                    num={3}
                    on_click={this.activate_map}
                    on_img={this.img_loaded}
                    app={app}
                    map_bts={false}
                    escala_for={this.state.images[3]}
                    map_border={false}
                    four_maps={this}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        :
          <table id='tablemaps_asym'>
            <tbody>
              <tr>
                <td colSpan='3'>
                  <Map
                    name='Map0'
                    num={0}
                    on_click={this.activate_map}
                    on_img={this.img_loaded}
                    app={app}
                    map_bts={false}
                    escala_for={this.state.images[0]}
                    map_border={false}
                    four_maps={this}
                  />
                  
                  {esc[0]}
                </td>
              </tr>
              <tr>
                <td>
                  <Map
                    name='Map1'
                    num={1}
                    on_click={this.activate_map}
                    on_img={this.img_loaded}
                    app={app}
                    map_bts={false}
                    escala_for={this.state.images[1]}
                    map_border={false}
                    four_maps={this}
                  />
                  
                  {esc[1]}
                </td>
                <td>
                  <Map
                    name='Map2'
                    num={2}
                    on_click={this.activate_map}
                    on_img={this.img_loaded}
                    app={app}
                    map_bts={false}
                    escala_for={this.state.images[2]}
                    map_border={false}
                    four_maps={this}
                  />
                  
                  {esc[2]}
                </td>
                <td>
                  <Map
                    name='Map3'
                    num={3}
                    on_click={this.activate_map}
                    on_img={this.img_loaded}
                    app={app}
                    map_bts={false}
                    escala_for={this.state.images[3]}
                    map_border={false}
                    four_maps={this}
                  />
                  
                  {esc[3]}
                </td>
              </tr>
            </tbody>
          </table>
        }
        
        {this.props.symmetric &&
          <Indicator
            active_map={this.state.active_map}
            show_tree={this.props.show_tree}
            width={this.props.width}
            height={this.props.height}
            show_dialog_user={this.props.show_dialog_user}
            show_dialog_tools={this.props.show_dialog_tools}
            full_height={this.props.full_height}
            app={app}
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/FourMaps.jsx